import { render, staticRenderFns } from "./Artmed360View.vue?vue&type=template&id=48433ded&"
import script from "./Artmed360View.vue?vue&type=script&lang=js&"
export * from "./Artmed360View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports